module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../node_modules/babel-loader/lib/index.js!./ContentListing.js"));
	}, "admin");
}


//////////////////
// WEBPACK FOOTER
// ./src/features/users/ContentListing.js
// module id = 1995
// module chunks = 4